const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/$/, '');
const API_BASE = `${API_URL}/api`;
const SOCKET_URL = (process.env.REACT_APP_SOCKET_URL || API_URL).replace(/\/$/, '');

export { API_URL, API_BASE, SOCKET_URL };
